export default __webpack_public_path__ + "static/media/p3.10acc5dd.jpg";